const ACTIONS = {
  FETCH_CHARGER_CONFIG_INIT: "FETCH_CHARGER_CONFIG_INIT",
  FETCH_CHARGER_CONFIG_SUCCESS: "FETCH_CHARGER_CONFIG_SUCCESS",
  FETCH_CHARGER_CONFIG_FAILURE: "FETCH_CHARGER_CONFIG_FAILURE",
};

export default ACTIONS;
